import axios from './axiosConfig'

interface CategoryData {
 name: string
 description?: string
 image?: File
 active?: boolean
}

export interface ReorderItem {
 id: number
 sort_order: number
}

export const categoriesAPI = {
 getAll: async (params?: any) => {
 const response = await axios.get('/categories', { params })
 return response.data
 },

 getById: async (id: number) => {
 const response = await axios.get(`/categories/${id}`)
 return response.data
 },

 create: async (data: CategoryData) => {
 const formData = new FormData()
 formData.append('name', data.name)
 if (data.description) formData.append('description', data.description)
 if (data.image) formData.append('image', data.image)
 if (data.active !== undefined) formData.append('active', String(Number(data.active)))

 const response = await axios.post('/categories', formData, {
 headers: { 'Content-Type': 'multipart/form-data' },
 })
 return response.data
 },

 update: async (id: number, data: CategoryData) => {
 const formData = new FormData()
 formData.append('_method', 'PUT')
 formData.append('name', data.name)
 if (data.description) formData.append('description', data.description)
 if (data.image) formData.append('image', data.image)
 if (data.active !== undefined) formData.append('active', String(Number(data.active)))

 const response = await axios.post(`/categories/${id}`, formData, {
 headers: { 'Content-Type': 'multipart/form-data' },
 })
 return response.data
 },

 delete: async (id: number) => {
 const response = await axios.delete(`/categories/${id}`)
 return response.data
 },

 reorder: async (items: ReorderItem[]) => {
 const response = await axios.post('/categories/reorder', { items })
 return response.data
 },

 reorderProducts: async (categoryId: number, items: ReorderItem[]) => {
 const response = await axios.post(`/categories/${categoryId}/products/reorder`, { items })
 return response.data
 },
}
